import React, { Component } from 'react';
import { CustomerBox } from './style';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { globalStateSelector } from '../../../../../store/selector';

export class CustomerDetail extends Component {
  render() {
    const { callInfo, customerNumber, customerName } = this.props;
    return (
      <CustomerBox>
        <div className="name">{customerNumber}</div>
        {/* <div className="company">{callInfo.agentId}</div> */}
        <div className="number">{customerName}</div>
        <div className="time">{callInfo.startTime}</div>
      </CustomerBox>
    );
  }
}
// customerNumber
// customerName
// startTime
// currentTime
CustomerDetail.propTypes = {
  callInfo: PropTypes.object,
  customerNumber: PropTypes.string,
  customerName: PropTypes.string
};
const stateToProps = state => ({
  callInfo: globalStateSelector.getInfo(state),
  userState: globalStateSelector.getState(state),
  customerNumber: globalStateSelector.getCallCustomerNumber(state),
  customerName: globalStateSelector.getCallCustomerName(state)
});

const dispatchToProps = dispatch => ({
  receiveSocketMessage: data => {}
});
export default connect(stateToProps, dispatchToProps)(CustomerDetail);



// WEBPACK FOOTER //
// src/dialpad/components/layout/components/call/CustomerDetail.js